import i from 'icepick'

const initialState = {
  users: {
    /**
     * [cachekey]: {
     *   data: [],
     *   numPages: integer,
     *   loading: boolean,
     * }
     */
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'USERS/GET_USERS_PENDING':
      return i.assocIn(state, ['users', action.meta.cacheKey, 'loading'], true)
    case 'USERS/GET_USERS_REJECTED':
      return i.assocIn(state, ['users', action.meta.cacheKey, 'loading'], false)
    case 'USERS/GET_USERS_FULFILLED':
      return i
        .chain(state)
        .assocIn(['users', action.meta.cacheKey, 'data'], action.payload.data)
        .assocIn(['users', action.meta.cacheKey, 'loading'], false)
        .assocIn(
          ['users', action.meta.cacheKey, 'numPages'],
          parseInt(action.payload.headers['x-total-count'] / 20, 10) + 1
        )
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Users/Users.reducer.js